import type { ReactNode } from 'react'

/* Section heading used above the home page sections and the launcher screens.
   Moved verbatim from player/src/App.tsx. */
export function SectionHead({ icon, title, children }: { icon: ReactNode; title: string; children?: ReactNode }) {
  return (
    <div className="flex items-center justify-between mt-9 mb-3.5">
      <h2 className="text-sm font-semibold flex items-center gap-2"><span className="text-[var(--muted)]">{icon}</span>{title}</h2>
      {children}
    </div>
  )
}
